import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
export function AGB() {
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900 flex flex-col" data-id="element-150">
      <Header forceSolid={true} data-id="element-151" />
      <main className="flex-grow pt-32 pb-24 px-4 sm:px-6 lg:px-8" data-id="element-152">
        <div className="max-w-4xl mx-auto bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-slate-200" data-id="element-153">
          <h1 className="text-3xl md:text-4xl font-bold text-slate-900 mb-8" data-id="element-154">
            Allgemeine Geschäftsbedingungen
          </h1>

          <div className="space-y-8 text-slate-600" data-id="element-155">
            <section data-id="element-156">
              <h2 className="text-xl font-semibold text-slate-900 mb-4" data-id="element-157">
                § 1 Geltungsbereich
              </h2>
              <p className="mb-4" data-id="element-158">
                (1) Die nachstehenden Bedingungen gelten für alle Verträge
                zwischen ellner consultancy und ihren Auftraggebern.
              </p>
              <p className="mb-4" data-id="element-159">
                (2) Abweichende, entgegenstehende oder ergänzende Allgemeine
                Geschäftsbedingungen des Auftraggebers werden, selbst bei
                Kenntnis, nicht Vertragsbestandteil, es sei denn, ihrer Geltung
                wird ausdrücklich zugestimmt.
              </p>
            </section>

            <section data-id="element-160">
              <h2 className="text-xl font-semibold text-slate-900 mb-4" data-id="element-161">
                § 2 Leistungen
              </h2>
              <p className="mb-4" data-id="element-162">
                (1) ellner consultancy erbringt Beratungs- und
                Schulungsleistungen im Bereich Projektmanagement sowie
                Interims-Management-Leistungen.
              </p>
              <p className="mb-4" data-id="element-163">
                (2) Der genaue Leistungsumfang ergibt sich aus dem jeweiligen
                Angebot oder Vertrag.
              </p>
            </section>

            <section data-id="element-164">
              <h2 className="text-xl font-semibold text-slate-900 mb-4" data-id="element-165">
                § 3 Vergütung und Zahlungsbedingungen
              </h2>
              <p className="mb-4" data-id="element-166">
                (1) Die Vergütung richtet sich nach den vertraglichen
                Vereinbarungen.
              </p>
              <p className="mb-4" data-id="element-167">
                (2) Rechnungen sind, sofern nicht anders vereinbart, innerhalb
                von 14 Tagen nach Rechnungsstellung ohne Abzug zahlbar.
              </p>
            </section>

            <section data-id="element-168">
              <h2 className="text-xl font-semibold text-slate-900 mb-4" data-id="element-169">
                § 4 Haftung
              </h2>
              <p className="mb-4" data-id="element-170">
                (1) ellner consultancy haftet für Schäden, die auf einer
                vorsätzlichen oder grob fahrlässigen Pflichtverletzung beruhen.
              </p>
            </section>

            <div className="p-4 bg-blue-50 border border-blue-100 rounded-lg text-sm text-blue-800 mt-8" data-id="element-171">
              <strong data-id="element-172">Hinweis:</strong> Dies ist ein Platzhalter. Bitte lassen
              Sie Ihre AGB von einem Rechtsanwalt prüfen und an Ihre
              spezifischen Dienstleistungen anpassen.
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-173" />
    </div>;
}